import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Store } from 'redux';
import { configureClient } from './api/client';
import App from './modules/app/App';
import registerServiceWorker from './registerServiceWorker';
import { StoreState, configureStore } from './store';
import 'normalize.css';

const store: Store<StoreState> = configureStore();
configureClient(store);

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx